import { ColorTokenInlineData } from "./properties";
import { z } from "zod";
export const CollectionOrigin = z.object({
    id: z.string(),
    parentId: z.string().optional(),
    sourceIds: z.string().array(),
    collectionKeyMigrated: z.boolean(),
});
export const Collection = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    name: z.string(),
    description: z.string(),
    backgroundColor: ColorTokenInlineData.optional(),
    parentPersistentId: z.string().optional(),
    /**
     * ID of Select element property definition's option that corresponds to this collection.
     *
     * Each collection is represented by an option in a special kind of element property that
     * is present in each design system where a collections are present. The property is maintained
     * automatically and is not available to the user (see immutable element properties).
     *
     * Collections have an immutable element property that allows bridging places where element properites
     * can be selected (e.g. documentation blocks) with the concept of collection without having to add
     * specific logic for collection selection.
     */
    elementPropertyOptionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    sortOrder: z.string(),
    origin: CollectionOrigin.optional(),
});
